import { render } from "./RegistrationPaymentRequestsWithSignature.vue?vue&type=template&id=5c713724&scoped=true"
import script from "./RegistrationPaymentRequestsWithSignature.vue?vue&type=script&lang=js"
export * from "./RegistrationPaymentRequestsWithSignature.vue?vue&type=script&lang=js"

import "./RegistrationPaymentRequestsWithSignature.vue?vue&type=style&index=0&id=5c713724&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c713724"]])

export default __exports__